

const TutorWave = () => {
  useEffect(() => {
    document.title = "Home Tutors in Noida | TutorWave by The Lighthouse";

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "TutorWave helps parents find trusted home tutors in Noida for Classes 1-12. Connect with experienced tutors for personalized learning."
      );
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "home tutor in Noida, private tutor near me, home tuition Noida, tutors for class 9 10 11 12"
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "keywords";
      meta.content =
        "home tutor in Noida, private tutor near me, home tuition Noida, tutors for class 9 10 11 12";
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="tutorwave-container">
      <section className="hero">
        <div className="hero-overlay">
          <h1>Find the Best Home Tutors in Noida</h1>
          <p>
            TutorWave connects students with experienced and verified tutors
            for personalized home tuition across Noida and Delhi NCR.
          </p>

          <div className="hero-buttons">
            <a href="/contact" className="primary-btn">
              Request a Tutor
            </a>

            <a href="#teacher" className="secondary-btn">
              Become a Tutor
            </a>
          </div>
        </div>
      </section>

      <section className="section">
        <h2>Why Choose TutorWave?</h2>

        <div className="grid">
          <div className="card">
            <h3>Verified Tutors</h3>
            <p>Experienced teachers for all classes and subjects.</p>
          </div>

          <div className="card">
            <h3>Free Tutor Matching</h3>
            <p>Parents can find tutors without paying any platform fee.</p>
          </div>

          <div className="card">
            <h3>Personalized Learning</h3>
            <p>One-to-one attention for better academic performance.</p>
          </div>

          <div className="card">
            <h3>Fast Response</h3>
            <p>Get matched with tutors within 24 hours.</p>
          </div>
        </div>
      </section>

      <section className="section light">
        <h2>Home Tuition Available In</h2>
        <p>
          All sectors of Noida, Greater Noida, Ghaziabad, Delhi, 
          Dwarka, Gurgaon, and across the entire Delhi NCR region. 
          Find the best home tuition near you with experienced and verified tutors for all classes.
        </p>
      </section>

      <section className="section" id="teacher">
        <h2>Teachers Can Join TutorWave</h2>
        <p>
          If you are a teacher looking for home tuition opportunities,
          register with TutorWave to receive genuine tuition leads.
        </p>

        <a href="/contact" className="primary-btn">
          Register as Tutor
        </a>
      </section>

      <section className="section light">
        <h2>Best Home Tuition Services in Noida</h2>
        <p>
          TutorWave is an initiative by The Lighthouse Coaching Institute
          to help parents find reliable home tutors in Noida. Our tutors
          specialize in Mathematics, Science, English, and board exam
          preparation for CBSE students.
        </p>
      </section>

      <section className="section faq-section">
        <h2>Frequently Asked Questions</h2>

        <div className="faq">
          <div className="faq-item">
            <h3>How can I find a home tutor in Noida?</h3>
            <p>
              Simply request a tutor through TutorWave and we will connect
              you with experienced teachers in your area.
            </p>
          </div>

          <div className="faq-item">
            <h3>Is TutorWave free for parents?</h3>
            <p>
              Yes, TutorWave provides tutor connections completely free
              for parents.
            </p>
          </div>

          <div className="faq-item">
            <h3>Which classes do your tutors teach?</h3>
            <p>
              Our tutors teach students from Class 1 to Class 12 including
              board exam preparation.
            </p>
          </div>

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "EducationalOrganization",
                name: "TutorWave",
                areaServed: "Noida",
                description:
                  "Home tutors for students from class 1 to 12 in Noida",
                provider: {
                  "@type": "Organization",
                  name: "The Lighthouse Coaching Institute",
                },
              }),
            }}
          />
        </div>
      </section>
    </div>
  );
};

export default TutorWave;
